const Path = require( '@leverege/path' )
const { promisify } = require( 'util' )
const toCsvBad = require( 'jsonexport' )
const ObjectUtil = require( '@leverege/object-util' )

function toCsv( ...args ) {
  return new Promise( ( res, rej ) => {
    toCsvBad( ...args, { fillGaps : false }, ( err, data ) => {
      if ( err ) {
        rej( err )
      } else {
        res( data )
      }
    } )
  } )
}

function cleanObject( cols, data ) {
  const nData = ObjectUtil.flatten( data, '/' )

  cols.forEach( ( col ) => {
    delete nData[col.path]
  } )

  return ObjectUtil.unflatten( nData, '/' )
}

async function exportAndSaveCSV( cols, data, filename = 'export.csv' ) {
  const toExport = colDataToExport( cols, data )
  const csv = await toCsv( toExport )
  const blob = new Blob( [ csv ], { type : 'text/plain' } )
  const url = URL.createObjectURL( blob )
  saveAs( url, filename )
}

async function exportAndSaveJson( cols, data, filename = 'export.json' ) {
  const toExport = colDataToExport( cols, data, false )
  const blob = new Blob( [ JSON.stringify( toExport ) ], { type : 'application/json' } )
  const url = URL.createObjectURL( blob )
  saveAs( url, filename )
}

async function exportAndSaveDotEnv( data, filename = 'export.env' ) {
  const blob = new Blob( [ data ], { type : 'text/plain' } )
  const url = URL.createObjectURL( blob )
  saveAs( url, filename )
}

function colDataToExport( cols, data, stringify = true ) {
  let toExport = data

  if ( cols ) {
    toExport = data.map( ( item ) => {
      const toReturn = {}
      cols.forEach( ( col ) => {
        const { path } = col
        Path( path ).set( toReturn, Path( path ).get( item ) )
      } )

      const notInData = cleanObject( cols, data )
      if ( Object.keys( notInData ).length > 0 ) {
        Path( 'NOT_IN_BP' ).set( toReturn, stringify ? JSON.stringify( notInData ) : notInData )
      }
      
      return toReturn
    } )
  }

  return toExport
}

// from http://stackoverflow.com/questions/283956/
function saveAs( uri, filename ) {
  const link = document.createElement( 'a' )
  if ( typeof link.download === 'string' ) {
    document.body.appendChild( link )// Firefox requires the link to be in the body
    link.download = filename
    link.href = uri
    link.click()
    document.body.removeChild( link ) // remove the link when done
  } else {
    location.replace( uri )
  }
}

module.exports = {
  exportAndSaveCSV,
  exportAndSaveJson,
  exportAndSaveDotEnv,
  cleanObject
}
